import { useApiHelper } from "../../utils/helper/apiHelper";

export const NewsService = () => {
  const { post } = useApiHelper();

  const fetchNews = async () => {
    const obj = {
      procName: "News",
      Para: JSON.stringify({ ActionMode: "Select" }), // Your parameter object pattern
    };
    try {
      const res = await post(import.meta.env.VITE_APP_API_URL + "/ExecuteProcedure", obj);
      return res;
    } catch (err) {
      console.error("News API Error", err);
      return [];
    }
  };

  return { fetchNews };
};
